'use strict';
var BrandsController = /** @class */ (function () {
    /*@ngInject*/
    function BrandsController($scope, BrandsService, $state, $stateParams, seoMetaService) {
        var _this = this;
        this.isHeroTabs = true;
        this.$scope = $scope;
        this.seoMetaService = seoMetaService;
        this.$state = $state;
        this.seoMetaService.updateSeoMetaData(this, 'BrandsController');
        BrandsService.getbrandFilter($stateParams.filterItem)
            .then(function (response) {
            _this.allBrands = response;
        });
        this.shopbrand = function (brandName, brandId) {
            var filterValue = this.urlStrip(brandName) + '-B' + brandId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
        BrandsService.getBrands()
            .then(function (response) {
            _this.brands = response;
        });
    }
    BrandsController.prototype.urlStrip = function (str) {
        if (str) {
            return str.replace(/[^\w\d\s]*/g, '').replace(/\s+/g, '-');
            // strip special characters and join words with '-'
        }
        else {
            return 'brand'; // default value brand
        }
    };
    BrandsController.prototype.getBrandUrl = function (brandName, brandId) {
        var filterValue = this.urlStrip(brandName) + '-B' + brandId;
        var brandUrl = this.$state.href('searchResults', { searchFilter: filterValue });
        return brandUrl;
    };
    return BrandsController;
}());
export default BrandsController;
//# sourceMappingURL=brands.controller.js.map